<template>
  <div class="contendMenu">
    <!-- 菜单部分样式 
    :style="{width: isCollapse? '64px': '200px'}"
      -->
    <div class="log"> 
      <img :src="systemInfo.v_log_file_url || log" />
    </div>
    <el-menu
      class="el-menu-vertical-demo"
      :collapse="isCollapse"
      text-color="white"
      active-text-color="white"
      :collapse-transition="true"
      :default-active="menuCurrentList[1].path"
      router
    >
    <!-- :unique-opened="true" -->
      <template v-for="(item, index) in routers">
        <el-submenu v-if="!item.hidden" :key="item.id" :index="index + ''">
          <!-- 一级菜单 -->
          <template slot="title">
            <svg-icon :icon-class="item.meta.icon" class="svg-icon_menu" />
            <span slot="title">{{ item.meta.name }}</span>
          </template>
          <!-- 子级菜单 -->
          <template v-for="subItem in item.children">
            <el-menu-item v-if="!subItem.hidden" :key="subItem.id" :index="subItem.path">
              <svg-icon :icon-class="subItem.meta.icon" class="svg-icon_menu" />
              {{ subItem.meta.name }}
            </el-menu-item>
          </template>
        </el-submenu>
      </template>
    </el-menu>
  </div>
</template>
<script>
import menu from './js/menu.js'
export default {
  mixins: [menu]
}
</script>
<style lang="scss">
@import "./css/menuElement.scss";
</style>
<style lang="scss" scoped>
@import "./css/menu.scss";
</style>
